import { useLocation } from "react-router-dom";

export function useQuery(name) {
  const searchParams = new URLSearchParams(useLocation().search);
  return searchParams.get(name);
}
